import { render, staticRenderFns } from "./EpiCalendar.vue?vue&type=template&id=51bdf57b&scoped=true"
import script from "./EpiCalendar.vue?vue&type=script&lang=js"
export * from "./EpiCalendar.vue?vue&type=script&lang=js"
import style0 from "./EpiCalendar.vue?vue&type=style&index=0&id=51bdf57b&prod&lang=stylus"
import style1 from "./EpiCalendar.vue?vue&type=style&index=1&id=51bdf57b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bdf57b",
  null
  
)

export default component.exports